import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";

const char = "\u2000";
function TextMaskCep({ inputRef, ...other }) {
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={char}
      mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
    />
  );
}

TextMaskCep.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default TextMaskCep;
